import auth0 from 'auth0-js';
import { clientId, domain, scope } from '../config';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const auth = new auth0.WebAuth({
  domain: domain || '',
  clientID: clientId || '',
  scope: scope || '',
});

export const forgotPassword = async (
  email: FormDataEntryValue | null
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `https://${domain}/dbconnections/change_password`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: {
      client_id: clientId,
      email: email,
      connection: 'Username-Password-Authentication',
    },
  };
  return await axios.request(config);
};
